// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"greater-than-or-equal"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 3L19 8.5L5 14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 20H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GreaterThanOrEqualIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'greater-than-or-equal',
    ref,
    icon: element,
  },
));

GreaterThanOrEqualIcon.displayName = 'GreaterThanOrEqualIcon';

export default GreaterThanOrEqualIcon;
